<template>
  <div @click="showRecentSearch=false">
    <div class="searchBox bodyWrap">
      <img :src="'logo.png' | imagePath" class="serchBox-logo pointer" @click="$.router.push('index')"/>
      <div class="searchBox-search">
        <div class="searchBox-search-main" style="position: relative;">
          <input
          type="text"
          placeholder="产品名称/型号/品牌/关键字"
          v-model="keyword"
          @click.stop="searchFocus"
          v-on:input="changeKeyword(keyword)"
          @keyup.enter="searchClick(keyword)">
          <div class="recentSearch"
          v-show="showRecentSearch && recentSearchWord.length!==0"
          style="
          position: absolute;
          top: 42px;
          left: -2px;
          background-color: #FFFFFF;
          z-index: 99;
          width: 786px;
          padding: 15px;
          box-shadow: 0 0 4px rgb(0 0 0 / 20%);
          min-height: 100px;
          ">
            <div class="recentSearch-title">
              最近搜索
              <button @click="recentSearchCancel">清空</button>
            </div>
            <ul class="recentSearch-list">
              <li class="pointer"
                  v-for="(item,index) in recentSearchWord"
                  :key="index">
                  <el-tag
                    closable
                    :disable-transitions="false"
                    size="small"
                    type="info"
                    effect="plain"
                    @click="recentSearchClick(item)"
                    @close="removeCurrent(index)">
                    {{item}}
                  </el-tag>
              </li>
            </ul>
          </div>
          <span
          @click="searchClick(keyword)"
          class="searchBox-search-main-btn pointer">
            <img :src="'icon_head_search.png' | imagePath" />
          </span>
        </div>
        <ul class="searchBox-search-main-hot">
          <li v-for="(item,index) in hotSearchWord" v-show="index<10" :key="index">
            <a :title="item" :href="('goodsList?keyword='+item) | hrefFormat">{{item}}</a>
          </li>
        </ul>
      </div>
      <div style="margin-top:32px">
        <div class="quick-inquiry">
          <a :href="('PriceInquiry') | hrefFormat">
            快速询价
            <svg  t="1644396158606" class="icon icon-money" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2203" width="200" height="200"><path d="M911.5 699.7c-1.5-4.2-6.1-6.3-10.3-4.8L840 717.2V179c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-0.9-0.3-1.8-0.5-2.7-0.5-4.4 0-8 3.6-8 8V762c0 3.3 2.1 6.3 5.3 7.5L501 909.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-0.2-1.9-0.5-2.8z m-243.8-377L564 514.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V703c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 322.8c-2.1-3.8-0.7-8.7 3.2-10.8 1.2-0.7 2.5-1 3.8-1h55.7c3 0 5.7 1.7 7.1 4.4L511 484.2h3.3L599 315.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-0.4 2.6-1 3.8z" p-id="2204" fill="#e60012"></path></svg>
          </a>
        </div>
        <mini-cart/>
      </div>
    </div>
    <div class="navBox bodyWrap" >
      <div class="nav-all" @mouseleave="categoryNavleave();categoryIndex=-1" v-if="mode==='normal'">
        <div class="nav-all-btn pointer" @mouseenter="categoryNavHover()">
          <img :src="'icon_nav_ classify.png' | imagePath" />
          全部产品分类
        </div>
        <!--  -->
        <ul class="nav-all-child"
            @mouseenter="categoryHoverIndex = 1"
            @mouseleave="categoryHoverLeave(0)"
            v-if="isShow"
            >
          <li
          :class="categoryIndex== index ? 'active':''"
          class="pointer"
          @mouseenter="categoryHoverEnter(0,index)"
          :key="index"
          v-for="(item,index) in categoryList"
          >
          <a :href="'goodsList?cat_id='+item.cat_id | hrefFormat" target="_blank">
            <span></span><p>{{item.name}}</p>
            <img :src="categoryIndex== index ? 'icon_goods_type_active.png' : 'icon_goods_type.png' | imagePath" />
          </a>
         </li>
        </ul>
        <div class="nav-all-second" v-if="categoryHoverIndex != 0"
        @mouseenter="categoryHoverEnter(1)"
        @mouseleave="categoryHoverLeave(1)">
          <template v-if="categoryIndex > -1">
            <div class="nav-all-second-list" v-for="(val,index) in categoryList[categoryIndex].children"
          :key="index">
              <a :href="'goodsList?cat_id='+val.cat_id | hrefFormat"><h1>{{val.name}}</h1></a>
              <div class="nav-all-second-picture">
                <a :href="'goodsList?cat_id='+citem.cat_id | hrefFormat"
                  class="nav-all-second-picture-item"
                  :title="citem.name"
                  v-for="(citem,childIndex) in val.children"
                  :key="childIndex">
                  <!-- <img :src="citem.image" class="nav-all-second-picture-item-picture"/> -->
                  <p>{{citem.name}}</p>
                </a>
              </div>
            </div>
          </template>
        </div>
      </div>
      <ul class="nav-right">
        <a
        @click="headNavClick(index)"
        :class="navIndex == index ? 'active':''"
        v-for="(item,index) in navHrefs"
        :href="item.hrefName"
        :target="item.is_blank ? '_blank' : ''"
        :key="index">
          <!-- <p @click.prevent="headHrefClick(index)">
            {{item.title}}
          </p> -->
         {{item.title}}
        </a>
      </ul>
    </div>
    <div style="border-bottom: 3px solid #E60012;"></div>
      <transition
        enter-active-class="animate__animated slideOutDown"
        leave-active-class=""
      >
        <div class="fixedSearch" v-show="showFixedSearch">
          <div class="searchBox bodyWrap" style="margin-top:10px !important;margin-bottom:10px !important;">
            <img :src="'logo.png' | imagePath" style="margin-top:0px" class="serchBox-logo pointer" @click="$.router.push('index')"/>
            <div class="searchBox-search" style="margin-top:10px !important;">
              <div class="searchBox-search-main">
                <input
                  type="text"
                  placeholder="产品名称/型号/品牌/关键字"
                  v-model="keyword"
                  v-on:input="changeKeyword(keyword)"
                  @keyup.enter="searchClick(keyword)">
                  <span
                    @click="searchClick(keyword)"
                    class="searchBox-search-main-btn pointer">
                    <img :src="'icon_head_search.png' | imagePath" />
                  </span>
              </div>
            </div>
            <div style="margin-top:12px">
              <div class="quick-inquiry">
                <a :href="('PriceInquiry') | hrefFormat">
                  快速询价
                  <svg  t="1644396158606" class="icon icon-money" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2203" width="200" height="200"><path d="M911.5 699.7c-1.5-4.2-6.1-6.3-10.3-4.8L840 717.2V179c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-0.9-0.3-1.8-0.5-2.7-0.5-4.4 0-8 3.6-8 8V762c0 3.3 2.1 6.3 5.3 7.5L501 909.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-0.2-1.9-0.5-2.8z m-243.8-377L564 514.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V703c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 322.8c-2.1-3.8-0.7-8.7 3.2-10.8 1.2-0.7 2.5-1 3.8-1h55.7c3 0 5.7 1.7 7.1 4.4L511 484.2h3.3L599 315.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-0.4 2.6-1 3.8z" p-id="2204" fill="#e60012"></path></svg>
                </a>
              </div>
              <mini-cart/>
            </div>
          </div>
        </div>
      </transition>
  </div>
</template>

<script>
  import MiniCart from "@/components/MiniCart"
  export default{
    props: {
      isShow:Boolean,
      navIndex:[Number,String],
      mode: {
        type: String,
        default: "normal",
      }
    },
    data(){
      return{
        financeUrl:process.env.NODE_HOST+'/api/supplier/agreements?type=28&html=1',
        keyword:this.$route.query.keyword ? this.$route.query.keyword : '',
        carNum:0,
        categoryHoverIndex: 0,//0没在上面 1在左边 2在右边
        categoryList:[],
        categorySecond:[],
        categoryIndex:-1,
        category_id:0,
        // recommendNorm:[],
        recommendAlloy:[],
        recommendStatus:[],
        recommendType:[],
        hotSearchWord:[],
        serchWord:'',
        recentSearchWord:[],
        showRecentSearch:false,
        navHrefs:[
          // {title:'首页',hrefName:'index',index:0},
          // {title:'品牌',hrefName: 'brand',index:1},
          // {title:'积分商城',hrefName: 'scoreShop',index:2},
          // {title:'优惠促销',hrefName: 'goodsActivity',index:3},
          // {title:'供应链金融',hrefName: 'finance',index:4},
          // {title:'行业解决方案',hrefName: 'industry',index:5},
          // {title:'资讯',hrefName: 'information',index:6}
        ],
        showFixedSearch: false
      }
    },
    created(){
      this.$.storage.setItem('search_keyword', this.keyword);
    },
    methods:{
      getActiveType() {
        this.$.http.post('index/getValidActivities','',false,false,false).then(res=>{
          this.goodsType = res.data
          // if(res.data.length == 0){
          //   this.navHrefs = [
          //     {title:'首页',hrefName:'index',index:0,type:1},
          //     {title:'品牌',hrefName: 'brand',index:1,type:1},
          //     {title:'积分商城',hrefName: 'scoreShop',index:2,type:1},
          //     {title:'供应链金融',hrefName: 'finance',index:3,type:1},
          //     {title:'行业解决方案',hrefName: 'industry',index:4,type:1},
          //     {title:'资讯',hrefName: 'https://www.mro365.com/article-11/',index:5,type:2}
          //   ]
          // } else {
          //   this.navHrefs = [
          //     {title:'首页',hrefName:'index',index:0,type:1},
          //     {title:'品牌',hrefName: 'brand',index:1,type:1},
          //     {title:'积分商城',hrefName: 'scoreShop',index:2,type:1},
          //     {title:'优惠促销',hrefName: 'goodsActivity',index:3,type:1},
          //     {title:'供应链金融',hrefName: 'finance',index:4,type:1},
          //     {title:'行业解决方案',hrefName: 'industry',index:5,type:1},
          //     {title:'资讯',hrefName: 'https://www.mro365.com/article-11/',index:6,type:2}
          //   ]
          // }
          return this.$.http.get('index/getnav','',false,false,false)
        }).then(res => {
            const { navs } = res.data
            if(navs && navs.length){
              const filter_nav  =Object.values(navs)
              .filter(item =>  (!this.goodsType.length && item.url!='/scoreShop') || this.goodsType.length )
              .sort((a,b) => a.sort - b.sort)
              .map((item,index) =>  Object.assign( { title:item.name,hrefName:item.url,index,is_blank:item.is_blank } ))
              this.navHrefs = filter_nav
            }
        })
      },
      // 头部导航切换事件
      headNavClick(index) {
        this.$emit('change',{index:index});
      },
      headHrefClick(index) {
        const { hrefName,is_blank } = this.navHrefs[index]
        if(hrefName == '/finance' || hrefName == "/industry"){
          if(!this.$.user.userLogin()){
            this.$message.warning('请先登录账号')
            return
          }
        }
        console.log(is_blank)
        if(is_blank){
          window.open(hrefName,'_blank');
        }else{
          window.location.href = hrefName
        }
      },
      //全部分类鼠标事件
      categoryNavHover() {
        this.$emit('showAllNav',{isShow:this.isShow})
      },
      categoryNavleave() {
        this.$emit('hideAllNav',{isShow:this.isShow})
      },
      // 全部产品分类-一级分类鼠标事件
      categoryHoverEnter(type,index) {
        if (type == 0) {
          this.categoryIndex = index
          this.categorySecond = this.categoryList[index].arr
          this.category_id  = this.categoryList[index].id
        } else {
          this.categoryHoverIndex = 2
        }
      },
      categoryHoverLeave(type){
        if (type == 0) {
          setTimeout(() => {
            if (this.categoryHoverIndex == 1) this.categoryHoverIndex = 0
          },100)
        } else {
          this.categoryIndex = -1
          setTimeout(() => {
            if (this.categoryHoverIndex == 2) this.categoryHoverIndex = 0
          },100)
        }
      },
      //全部产品分类
      getCategoryList() {
        this.$.http.post('basic/categories/tree/1').then(res=>{
          this.categoryList = res.data
        })
      },
      // 搜索点击事件
      searchClick(keyword) {
        if(this.$route.name == 'goodsList'){
          this.$emit('goodsList',{keyword:keyword})
          this.$.storage.setItem('search_keyword', keyword)
        } else {
          this.$.router.push('/goodsList',{keyword:this.keyword || ''})
        }
        if(this.serchWord == '') {
          this.serchWord = keyword
        } else {
          let searchWords = this.serchWord.split('|')
          if(searchWords.indexOf(keyword) == -1){
            this.serchWord = keyword + '|' + this.serchWord
          }
        }
        sessionStorage.setItem('serchWord',this.serchWord)
        this.showRecentSearch = false
      },
      // 最近搜索点击事件
      recentSearchClick(keyword) {
        this.keyword = keyword
        if(this.$route.name == 'index'){
          this.$.router.push('/goodsList',{keyword:this.keyword || ''})
        } else {
          this.$emit('search',{keyword:keyword})
          this.$.storage.setItem('search_keyword', keyword)
        }
        this.showRecentSearch = false
      },
      removeCurrent(index){
        this.recentSearchWord.splice(index, 1);
        this.serchWord = this.recentSearchWord.join("|")
        sessionStorage.setItem('serchWord',this.serchWord)
      },
      // 清空最近搜索
      recentSearchCancel() {
        this.showRecentSearch = false
        sessionStorage.clear('serchWord')
        this.serchWord = ''
        this.recentSearchWord = []
      },
      // 搜索框获取焦点
      searchFocus() {
        this.showRecentSearch = true
        console.log(this.serchWord)
        if(this.serchWord){
          var arr = this.serchWord.split('|')
          var newArr = []
          for (var i = 0; i < arr.length; i++) {
            if (newArr.indexOf(arr[i]) === -1 || arr[i] !== '') {
              newArr.push(arr[i])
            }
          }
          this.serchWord = newArr.join('|')
          this.recentSearchWord = this.serchWord.split('|')
        }
      },

      changeKeyword(keyword){
        this.$.storage.setItem('search_keyword', keyword)
      },

      showSearch() {
        // 获取当前滚动条向下滚动的距离
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        // 当页面滚动到高度300px处时，显示搜索框
        if (scrollTop > 300) {
          this.showFixedSearch = true;
        } else {
          this.showFixedSearch = false;
        }
      }
    },
    mounted() {
      this.hotSearchWord = this.$.storage.getItem('hotSearchWord') ? this.$.storage.getItem('hotSearchWord').split('|') : ''
      this.getActiveType()
      this.serchWord =  sessionStorage.getItem('serchWord') ? sessionStorage.getItem('serchWord') : ""
      this.getCategoryList()
      window.addEventListener("scroll", this.showSearch)
    },
    components:{
      MiniCart
    }
  }
</script>

<style>
  .searchBox{
    display: flex;
    margin-top: 23px !important;
    margin-bottom: 20px !important;
    position: relative;
  }
  .serchBox-logo{
    display: block;
    width: 208px;
    height: 66px;
    cursor: pointer;
  }
  .searchBox-search{
    margin: 30px 26px 0 76px;
    width: 600px;
  }
  .searchBox-search-main{
    display: flex;
    align-items: center;
  }
  .searchBox-search-main input{
    padding: 0 20px;
    flex-grow: 1;
    font-size: 12px;
  }

  .searchBox-search-main{
    border: 2px solid #E60012;
    height: 38px;
    font-size: 12px;
  }
  .searchBox-search-main-btn{
    background-color: #E60012;
    width: 87px;
    height:100%;
    display: flex;
    justify-content: center;
    align-items:center;
  }

  .navBox{
    display: flex;
    margin-top: 20px;
  }
  .nav-all{
    width: 240px;
    position: relative;
    z-index: 8;
    position: relative;
  }
  .nav-all-btn {
    background-color: #E60012;
    color: #FFFFFF;
    line-height: 51px;
    padding: 0 15px;
    position: absolute;
    width: 210px;
    left: 0;
    bottom: -3px;
    display: flex;
    align-items: center;
    font-size: 16px;
  }
  .nav-all-btn img{
    width: 10px;
    height: 10px;
    margin-right: 20px;
  }
  .nav-all-child{
    background-color: rgba(255,255,255,0.8);
    /* padding: 10px 0; */
    width: 240px;
    position: absolute;
    top: 53px;
    left: 0;
    height: 520px;
    overflow: hidden;
    overflow-y: scroll;
  }
  .nav-all-child li a{
    height: 32px;
    display: flex;
    align-items: center;
    padding: 0 22px;
    font-size: 14px;
    margin: 10px 0;
    color: #333333;
  }
  .nav-all-child li.active{
    background-color: #FDE8E9;
    color: #E60012;
  }
  .nav-all-child li span{
    width: 6px;
    height: 6px;
    border-radius: 100%;
    border:1px solid #666666;
    margin-right:10px
  }
  .nav-all-child li.active span{
    border:1px solid #E60012;
  }
  .nav-all-child li p{
    flex-grow: 1;
  }

  .nav-all-child li img{
    width: 7px;
    height: 12px;
  }
  .nav-right{
    width: 800px;
    display: flex;
    line-height: 51px;
    height: 51px;
    margin-left: 43px;
    justify-content: space-between;
  }
  .nav-right a{
    font-size: 16px;
    color: #333333;
    padding: 0 15px;
  }
  .nav-right li{
    margin: 0 10px;
    font-size: 16px;
  }
  .nav-right li a{
    color: #333333;
  }
  .nav-right li:hover a{
    color: #E60012;
  }
  .nav-right li.active a{
    color: #E60012;
  }

  .nav-all-second{
    background-color: #FFFFFF;
    position: absolute;
    width: 953px;
    padding-bottom: 30px;
    height: 517px;
    left: 239px;
    top: 54px;
    border: 1px solid #EEEEEE;
    box-shadow: 0px 0px 18px 0px rgba(153, 153, 153, 0.3);
    overflow: hidden;
    overflow-y: scroll;
  }
  .nav-all-second h1{
    font-size: 16px;
    color: #3F3E3E;
    line-height: 50px;
    margin-left: 40px;
    font-weight: 400;
    color: #E60012;
  }
  .nav-all-second-picture{
    display: flex;
    margin-left: 20px;
    flex-wrap: wrap;
  }
  .nav-all-second-picture-item{
    overflow: hidden;
    margin-right: 20px;
    font-size: 14px;
  }
  .nav-all-second-picture-item p{
    color: #3F3E3E;
    text-align: center;
    line-height: 30px;
    width: 120px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .nav-all-second-picture-item:hover p{
    color: #E60012;
  }
  .nav-all-second-picture-item .nav-all-second-picture-item-picture{
    width: 60px;
    height: 60px;
    border-radius: 10px;
    display: block;
    margin:auto;
  }


  .nav-all-second-spec{
    display: flex;
    flex-wrap: wrap;
    color: #3F3E3E;
    font-size: 16px;
    margin-left: 40px;
  }
  .nav-all-second-spec a{
    margin-right: 66px;
    margin-bottom: 5px;
    color: #3F3E3E;
    font-size: 16px;
  }
  .nav-all-second-spec a:hover{
    color: #E60012;
  }
  .searchBox-search-main-hot{
    display: flex;
    align-items: center;
    margin-top: 5px;
  }
  .searchBox-search-main-hot li{
    font-size: 12px;
    margin-right: 30px;
    flex-shrink: 0;
  }
  .searchBox-search-main-hot li a{
    color: #828181;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  .searchBox-search-main-hot li a:hover{
    color: #E60012;
  }

  .recentSearch-title{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .recentSearch-title button{
    color: #f00;
  }
  .recentSearch-list{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 10px;
  }
  .recentSearch-list li{
    margin-right: 10px;
    margin-top: 10px;
    flex-shrink: 0;
    font-size: 14px;
  }

  .fixedSearch {
    position: fixed;
    top:0px;
    width: 100%;
    z-index: 999;
    background: #fff;
    box-shadow: 0 2px 10px rgb(0 0 0 / 20%);
    height: 78px;
    /* overflow: hidden; */
  }

  .quick-inquiry{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 38px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-top: 0;
    background-color: #ffffff;
    -webkit-box-shadow: 0px 2px 6px 0px rgb(35 24 21 / 19%);
    box-shadow: 0px 2px 6px 0px rgb(35 24 21 / 19%);
    padding: 0 12px;
    align-items: center;
    color: #333333;
    font-size: 14px;
    cursor: pointer;
    float: left;
    margin-right: 20px;
  }
  .icon-money{
    width: 20px;
    height: 20px;
  }
  .quick-inquiry a{
    display: flex;
    color: #333;
    justify-content: space-around;
    min-width: 108px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HeadNav/index.vue